(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('GFileStatus', GFileStatus);

    GFileStatus.$inject = ['$resource'];

    function GFileStatus ($resource) {
        var resourceUrl =  'api/gfile-status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
